module.exports = __webpack_public_path__ + "img/207-5a3acc.png";